export const vultureENV = window._getEnv('ENV');
export const broncoURL = window._getEnv('BRONCO_URL');
export const falconURL = window._getEnv('FALCON_WS_URL');
export const commitHash = window._getEnv('COMMITHASH');
export const apiKey = window._getEnv('TINYMCE_API_KEY');
export const previewHost = window._getEnv('PREVIEW_URL');
export const cardinalHost = window._getEnv('CARDINAL_URL');